export const EmptyList = (props:any) => {
    return(
        <div style={{display:'flex', justifyContent:'center', alignItems:'center', fontWeight:'600', fontSize:12, height:300, flexDirection:'column'}}>

                <span style={{display:'block', fontSize:16, color:'rgba(0, 0, 0, 0.87)', fontWeight:'400', marginBottom:5}}>{props.from === 'issued' ? 'No certificates issued yet':'No certificate requests yet'}</span>
                <span style={{display:'block', fontSize:16, color:'rgba(0, 0, 0, 0.60)', fontWeight:'400', marginBottom:24}}>{props.from === 'issued' ? 'Once requests are approved and certificates issued, they’ll appear here.':'You’ll see all submitted requests here once available.'}</span>
        </div>
    )
}